import React from 'react';

const UndoLabel = () => (
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0.85896 7.85305C0.543026 7.53712 0.543026 7.02489 0.85896 6.70895L7.33096 0.236954C7.64689 -0.0789795 8.15912 -0.0789795 8.47506 0.236954C8.79099 0.552889 8.79099 1.06512 8.47506 1.38105L3.38411 6.472H19.229C21.463 6.472 23.274 8.28301 23.274 10.517V23.461C23.274 23.9078 22.9118 24.27 22.465 24.27C22.0182 24.27 21.656 23.9078 21.656 23.461V10.517C21.656 9.17661 20.5694 8.09 19.229 8.09H3.38411L8.47506 13.181C8.79099 13.4969 8.79099 14.0091 8.47506 14.3251C8.15912 14.641 7.64689 14.641 7.33096 14.3251L0.85896 7.85305Z" fill="#141414"/>
</svg>
);

export default UndoLabel;
